import AclHOC from '@platform/react/hoc/acl'
import useMemoRef from '@platform/react/hook/useMemoRef'
import FabButton from '@ui/Element/Button/Fab'

const AclFabButton = useMemoRef(AclHOC(FabButton), [])
export default AclFabButton
